var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"midTop"}},[_c('div',{staticClass:"bg-color-black"},[_c('myTitle',{attrs:{"icon":'chart-bar'}},[_vm._v("实时电量")]),_c('div',[_c('bottomRightTopChart')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }